
	import {
		defineComponent,
		onMounted,
		ref,
		reactive
	} from 'vue';
    import infotask from '@/service/infotask'
    import {
        message
    } from 'ant-design-vue';

	export default defineComponent({
		components: {

		},
		setup() {
			// 声明
			let visible = ref(false);
			let formState = reactive({
                taskName: '',
                applyStartTime: '',
                applyEndTime: '',
                allotStartTime: '',
                allotEndTime: '',
                reviewStartTime: '',
                reviewEndTime: '',
                arbitrateStartTime: '',
                arbitrateEndTime: '',
                arbitrateScore: '',
                ifLogin: '',
                opinionWordsNumber: '',
                reviewLevel: '',
                ifTqjsReview: '',
                ifTxkjsReview: '',
                ifTxdjsReview: '',
                subjectScope: '',
                studyPhase: '',
                introduction: '',
                createTime: ''
			});

			// 页面渲染时加载
			onMounted(() => {
			})
			// 打开页面
			const open = (e) => {
                if (e) {
                    infotask.getActivity(e.id).then(({data}) => {
                        if (data.code == '0') {
                            formState.taskName = data.data.taskName;
                            formState.applyStartTime = data.data.applyStartTime;
                            formState.applyEndTime = data.data.applyEndTime;
                            formState.allotStartTime = data.data.allotStartTime;
                            formState.allotEndTime = data.data.allotEndTime;
                            formState.reviewStartTime = data.data.reviewStartTime;
                            formState.reviewEndTime = data.data.reviewEndTime;
                            formState.arbitrateStartTime = data.data.arbitrateStartTime;
                            formState.arbitrateEndTime = data.data.arbitrateEndTime;
                            formState.arbitrateScore = data.data.arbitrateScore;
                            formState.ifLogin = data.data.ifLogin == '0' ? '否' : '是';
                            formState.reviewLevel = data.data.reviewLevel == '0' ? '否' : '是';
                            formState.ifTqjsReview = data.data.ifTqjsReview == '0' ? '否' : '是';
                            formState.ifTxkjsReview = data.data.ifTxkjsReview == '0' ? '否' : '是';
                            formState.ifTxdjsReview = data.data.ifTxdjsReview == '0' ? '否' : '是';
                            formState.subjectScope = data.data.subjectScope;
                            formState.studyPhase = data.data.studyPhase;
                            formState.introduction = data.data.introduction;
                            formState.createTime = data.data.createTime;
                            formState.opinionWordsNumber = data.data.opinionWordsNumber;
                        } else {
                            message.error(data.msg);
                        }
                    })
                }
                visible.value = true;
			}
			return {
				open,
				visible,
				formState,
			};
		},

	});
